export default "__VITE_ASSET__DCDXWae7__"